import { Layout } from '@repo/types';
import Row from './Row';
import { CmsComponentsMap } from './contracts';
import { CmsComponentsMapProvider } from './CmsComponentsMapContext';

export type GeneratePageProps = Layout & {
  /**
   * SC-1213: which component registry to render from. `App.tsx` supplies the lazy
   * `cmsWebComponentsMap`; `ServerApp.tsx` supplies the static
   * `cmsServerComponentsMap` so SSR emits real markup.
   */
  componentsMap: CmsComponentsMap;
};

export const GeneratePage = ({ rootChildren, rows, columns, components, componentsMap }: GeneratePageProps) => {
  const rootRows = rootChildren.map((rowId) => rows[rowId]!);
  const tree: Omit<Layout, 'rootChildren'> = {
    rows,
    columns,
    components,
  };

  return (
    <CmsComponentsMapProvider componentsMap={componentsMap}>
      {rootRows.map((row, index) => (
        <Row key={row.id} id={row.id} tree={tree} isAboveFold={index === 0} componentsMap={componentsMap} />
      ))}
    </CmsComponentsMapProvider>
  );
};
